<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
// 应用根组件
</script>

<style lang="less">
#app {
  height: 100vh;
  width: 100vw;
}
</style>